/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * this is the schema for the result of the entities search function
 */
export interface EntitySearchColumn { 
    data?: string;
    value?: string;
}

